import loadExternalProvidersWithReturn from "@husky-hrc/Framework/Handlers/Data/SignIn/LoadExternalProviders";
import { getExternalProvidersByUrl } from "@husky-hrc/Framework/Store/Data/SignIn/SignInSelector";
import ExtendedApplicationState from "@husky-hrc/Framework/Store/ExtendedApplicationState";
import { redirectToAuthProviderUrl } from "@husky-hrc/Utilities/HuskyExternalAuth";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ExternalProviderLinkModel } from "@insite/client-framework/Services/IdentityService";
import { getLocation, removeAbsoluteUrl } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ExtendedApplicationState) => {
    const returnUrl = removeAbsoluteUrl(getLocation(state).pathname);
    return {
        externalProvidersState: getExternalProvidersByUrl(state, returnUrl),
        returnUrl,
        userName: state.context.session.userName,
    };
};

const mapDispatchToProps = {
    loadExternalProvidersWithReturn,
};

interface OwnProps {
    extendedStyles?: ButtonPresentationProps;
    authButtonText?: string;
    variant: "primary" | "secondary" | "tertiary";
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const externalAuthButtonStyles: ButtonPresentationProps = {};

const ExternalAuthButton = ({
    externalProvidersState,
    returnUrl,
    userName,
    loadExternalProvidersWithReturn,
    authButtonText,
    extendedStyles,
    variant,
}: Props) => {
    const [styles] = React.useState(() => mergeToNew(externalAuthButtonStyles, extendedStyles));

    useEffect(() => {
        if (!userName && !externalProvidersState.value && !externalProvidersState.isLoading) {
            loadExternalProvidersWithReturn({ returnUrl });
        }
    }, [returnUrl]);

    const providerButtonClickHandler = (externalProviders: ExternalProviderLinkModel[] | undefined) => {
        redirectToAuthProviderUrl(externalProviders);
    };

    if ((externalProvidersState.value?.externalProviders?.length ?? 0) === 0) {
        return null;
    }

    return (
        <>
            <Button
                {...styles}
                variant={variant}
                onClick={() => providerButtonClickHandler(externalProvidersState.value!.externalProviders)}
            >
                {translate(authButtonText || "")}
            </Button>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ExternalAuthButton);
